module.exports = __webpack_public_path__ + "img/model_50_zh.d12f6205.jpg";